<template>
  <main class="mx-auto pa-4">
    <div class="row">
      <b-col offset-md="2" offset-sm="1">
        <img
          src="@/assets/logo-vitalliance-2026.svg"
          alt="Vitalliance"
          width="175"
          height="48"
        />
      </b-col>
      <b-col class="mt-4" md="8" sm="10" offset-md="2" offset-sm="1">
        <section-title>
          {{ $t("qr-code-title") }}
        </section-title>

        <b-card class="mb-3 shadow">
          <p>
            {{ $t("qr-code-description") }}
          </p>

          <b-btn
            class="mt-2"
            size="sm"
            :href="'tel:' + $t('tel-number')"
            variant="primary"
          >
            <svgicon
              icon="phone"
              width="24"
              height="24"
              color="#ecbcd6"
            ></svgicon>
            {{ $t("tel-number") | formatPhone }}
          </b-btn>
        </b-card>
      </b-col>

      <b-col md="8" sm="10" offset-md="2" offset-sm="1">
        <vita-qr-code
          @qrCodeString="getQrCode"
          :width="512"
          :height="512"
        ></vita-qr-code>
      </b-col>

      <b-col md="8" sm="10" offset-md="2" offset-sm="1">
        <vita-address-client
          @readyAdressBlock="getIsReadyAdressBlock"
        ></vita-address-client>
      </b-col>
    </div>
  </main>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import VitaQrCode from "../../Documents/Telegestion/QrCode/QrCode.vue";
import VitaAddressClient from "./Address/Address.vue";

export default {
  components: {
    SectionTitle,
    VitaAddressClient,
    VitaQrCode
  },
  data() {
    return {
      isReadyAdressBlock: false,
      isQRCodeReady: false
    };
  },
  computed: {
    isReadyToPrint: function() {
      return this.isReadyAdressBlock && this.isQRCodeReady;
    }
  },
  watch: {
    isReadyToPrint() {
      setTimeout(function() {
        window.print();
      }, 2000);
    }
  },
  methods: {
    getQrCode(newQrCodeString) {
      if (newQrCodeString !== "") {
        this.isQRCodeReady = true;
      }
    },
    getIsReadyAdressBlock(isReadyAdressBlock) {
      this.isReadyAdressBlock = isReadyAdressBlock;
    }
  }
};
</script>
